import * as React from "react";
import {cs} from "../../../../../react/chain-services";
import "./subtle-badge.scss";
import {cx} from "emotion";

export const SubtleBadge = ({message, style=undefined, xdQaName=undefined}) => cs(
    () => (
        <div className={cx("subtle-badge-5zk", {danger: style?.color === "danger"})} xd-qa-type="label" xd-qa-name={xdQaName}>
            {message}
        </div>
    ),
);